import { assign } from 'xstate';

const setMaxStep = (max, step) => {
  // console.log('currentStep', max, step, ctx.currentStep)
  if (step < max) {
    return max;
  }
  return step;
};
export default {
  id: 'process',
  context: {
    maxStep: 0,
    currentStep: 0,
    coops: [],
    memberships: [],

    errors: {
      attachment: {},
    },
  },
  on: {
    WORKING: '.initializing.working',
  },
  initial: 'initializing',
  states: {
    initializing: {
      on: {
        STEP_1: 'step_1',
      },
      initial: 'working',
      states: {
        working: {
          invoke: {
            src: 'fetching',
            onDone: {
              target: '#process.welcome',
              actions: [
                assign({
                  coops: (ctx, event) => event.data[0],
                  memberships: (ctx, event) => {
                    const memberships = event.data[1].map((item) => {
                      item.total_fee = item.service_fees.reduce((acc, curr) => {
                        return acc + parseFloat(curr.price);
                      }, 0);
                      return item;
                    });
                    return memberships;
                  },
                }),
              ],
            },
            onError: {
              target: 'failure',
            },
          },
        },
        failure: {},
      },
    },
    welcome: {
      on: {
        PROCEED_TO_VIDEO: 'video.paused',
      },
    },
    video: {
      // on: {
      //   PROCEED_TO_PRICES: 'step_1',
      // },
      states: {
        paused: {
          on: {
            // VIDEO_TOGGLE: 'playing',
            VIDEO_ENDED: 'end',
          },
        },
        // playing: {
        //   on: {
        //     VIDEO_TOGGLE: 'paused',
        //     VIDEO_ENDED: 'end',
        //   }
        // },
        end: {
          on: {
            PROCEED_TO_PRICES: '#process.step_1',
          },
        },
      },
    },
    step_1: {
      entry: [
        assign({
          currentStep: 1,
          maxStep: (ctx) => setMaxStep(ctx.maxStep, 1),
        }),
      ],
      on: {
        PREV: 'video',
        NEXT: 'validate_step_1',
      },
      initial: 'valid',
      states: {
        valid: {},
        invalid: {},
        failure: {},
      },
    },
    validate_step_1: {
      invoke: {
        src: 'validateStep1',
        onDone: {
          target: 'step_2',
        },
        onError: {
          target: 'step_1.invalid',
          actions: ['validationError'],
        },
      },
    },
    step_2: {
      entry: [
        assign({
          currentStep: 2,
          maxStep: (ctx) => setMaxStep(ctx.maxStep, 2),
        }),
      ],
      on: {
        PREV: 'step_1',
        NEXT: 'validate_step_2',
      },
      initial: 'valid',
      states: {
        valid: {},
        invalid: {},
        failure: {},
      },
    },
    validate_step_2: {
      invoke: {
        src: 'validateStep2',
        onDone: {
          target: 'step_3',
        },
        onError: {
          target: 'step_2.failure',
          actions: ['validationError'],
        },
      },
    },
    step_3: {
      entry: [
        assign({
          currentStep: 3,
          maxStep: (ctx) => setMaxStep(ctx.maxStep, 3),
        }),
      ],
      on: {
        PREV: 'step_2',
        NEXT: 'validate_step_3',
      },
      initial: 'valid',
      states: {
        valid: {},
        invalid: {},
        failure: {},
      },
    },
    validate_step_3: {
      invoke: {
        src: 'validateStep3',
        onDone: {
          target: 'step_4',
        },
        onError: {
          target: 'step_3.invalid',
        },
      },
    },
    step_4: {
      entry: [
        assign({
          currentStep: 4,
          maxStep: (ctx) => setMaxStep(ctx.maxStep, 4),
        }),
      ],
      on: {
        PREV: 'step_3.valid',
        NEXT: 'validate_step_4',
      },
      initial: 'valid',
      states: {
        valid: {},
        invalid: {},
        failure: {},
      },
    },
    validate_step_4: {
      invoke: {
        src: 'validateStep4',
        onDone: {
          target: 'step_5',
        },
        onError: {
          target: 'step_4.invalid',
        },
      },
    },
    step_5: {
      entry: [
        assign({
          currentStep: 5,
          maxStep: (ctx) => setMaxStep(ctx.maxStep, 5),
        }),
      ],
      on: {
        PREV: 'step_4.valid',
        // SUBMIT: '.validate',
        // VALID: '.valid',
        NEXT: '.validate',
      },
      initial: 'valid',
      states: {
        valid: {},
        invalid: {},
        validate: {
          invoke: {
            src: 'validateStep5',
            onDone: {
              target: '#process.branch',
            },
            onError: {
              target: 'invalid',
              actions: ['validationError'],
            },
          },
        },
        done: {
          entry: ['success'],
        },
      },
    },
    branch: {
      entry: [
        assign({
          currentStep: 6,
          maxStep: (ctx) => setMaxStep(ctx.maxStep, 6),
        }),
      ],
      on: {
        PREV: 'step_5.valid',
        // VALID: '.valid',
        NEXT: '.validate',
        // SUBMIT: '.validate',
      },
      initial: 'idle',
      states: {
        idle: {},
        valid: {},
        validate: {
          invoke: {
            src: 'validateStep7',
            onDone: '#process.attachment',
            onError: 'invalid',
          },
        },
        invalid: {},
      },
    },
    confirmatory: {
      id: 'Confirmatory',
      entry: [
        assign({
          currentStep: 8,
          maxStep: (ctx) => setMaxStep(ctx.maxStep, 8),
        }),
      ],
      on: {
        PREV: 'attachment.idle',
        // SUBMIT: '.validate',
        // VALID: '.valid',
        // NEXT: '.validate',
        SUBMIT: '.validate',
      },
      initial: 'idle',
      states: {
        idle: {},
        valid: {},
        invalid: {
          // entry: ['validationError']
        },
        validate: {
          invoke: {
            src: 'validateStep6',
            onDone: '#process.submit.process',
            // onDone: '#process.attachment',
            onError: 'invalid',
          },
        },
        success: {
          entry: ['success'],
        },
        failure: {
          entry: ['failure'],
        },
      },
    },
    attachment: {
      id: 'Attachment',
      entry: [
        assign({
          currentStep: 6,
          maxStep: (ctx) => setMaxStep(ctx.maxStep, 6),
        }),
      ],
      on: {
        // PREV: 'confirmatory.valid',
        PREV: 'branch.valid',
        NEXT: '.validate',
      },
      initial: 'idle',
      states: {
        idle: {},
        validate: {
          invoke: {
            src: 'validateAttachment',
            // onDone: '#process.submit.process',
            onDone: {
              target: '#process.confirmatory',
              actions: assign({
                errors(ctx) {
                  return {
                    ...ctx.errors,
                    attachment: {},
                  };
                },
              }),
            },
            onError: {
              target: 'invalid',
              actions: ['setErrorAttachment'],
            },
          },
        },
        invalid: {},
      },
    },
    submit: {
      entry: [
        assign({
          currentStep: 9,
          maxStep: (ctx) => setMaxStep(ctx.maxStep, 9),
        }),
      ],
      states: {
        process: {
          invoke: {
            src: 'submitting',
            onDone: 'success',
            onError: 'failure',
          },
        },
        failure: {
          entry: ['failure'],
          on: {
            BACK_TO_FORM: '#Confirmatory',
            SUBMIT: 'process',
          },
        },
        success: {
          entry: ['success'],
        },
      },
    },
  },
};
